import { useQuery } from "@tanstack/react-query";
import { useAddInState } from "@/components/AddInStateProvider";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_MAINTENANCE_WORK_ORDER_JOB } from "@/constants/resultsLimits";
import { MaintenanceWorkOrderJob } from "@/models/MaintenanceWorkOrderJob";
import createGroupFilter from "@/utilities/createGroupFilter";

export function useMaintenanceWorkOrderJob(source?: string, ignoreCompleted = true) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  const { groups, groupFilterCondition } = useAddInState();

  return useQuery<MaintenanceWorkOrderJob[]>({
    queryKey: ["maintenanceWorkOrderJob", activeSessionId, groups, groupFilterCondition],

    queryFn: ({ signal }) => {
      const filter = createGroupFilter(groups, groupFilterCondition, {});
      return (
        geotabClient.call(
          "Get",
          {
            typeName: "MaintenanceWorkOrderJob",
            search: {
              deviceSearch: {
                fromDate: new Date(),
                ...filter,
              },

              fromDateCompleted: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
              toDateCompleted: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
              // maintenanceTypeSearch: {},
            },
            resultsLimit: RESULTS_LIMIT_MAINTENANCE_WORK_ORDER_JOB,
          },
          signal,
        ) as unknown as Promise<MaintenanceWorkOrderJob[]>
      ).then(requests =>
        requests.filter(
          req =>
            (source === undefined || req.maintenanceType.source === source) &&
            (!ignoreCompleted || (req.statusCode !== 5 && req.statusCode !== 6)),
        ),
      );
    },

    refetchInterval: 30000,
  });
}
